import React from "react";
import { Form } from "semantic-ui-react";
import { useState } from "react";
import { getZipCodeAddress } from "../../Services/locationsService";

const InputZipCode = ({ formik, name, handleSetAddressValues, ...props }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleZipChange = async (e) => {
    const zip = e.target.value;

    formik.setFieldTouched(name, true, false);
    formik.setFieldValue(name, zip);

    // Clear error immediately when user starts typing valid zip
    if (/^\d{5}$/.test(zip)) {
      setIsLoading(true);
      formik.setFieldError(name, ""); // Clear previous errors
      handleSetAddressValues("", ""); // Reset address while loading

      try {
        const response = await getZipCodeAddress(zip);
        handleSetAddressValues(response.placeName, response.stateAbbreviation);
      } catch (err) {
        formik.setFieldError(name, "Invalid ZIP Code");
      } finally {
        setIsLoading(false);
      }
    } else {
      // Basic validation for incorrect zip
      formik.setFieldError(name, "Please enter a valid value");
      handleSetAddressValues("", "");
    }
  };

  return (
    <Form.Field>
      <Form.Input
        id={name}
        name={name}
        maxLength={5}
        value={formik.values[name]}
        onChange={handleZipChange}
        loading={isLoading}
        {...props}
      />{" "}
    </Form.Field>
  );
};

export default InputZipCode;
